import { Component } from '@angular/core';

@Component({
  selector: 'ssg-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.less']
})
export class CompanyInfoComponent {
  constructor() { }
}
